import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import * as AOS from 'aos';
import Swiper from 'swiper'; 

import { OwlOptions } from 'ngx-owl-carousel-o';

// import 'slick-carousel';
import { Title, Meta } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';
interface Card {
    id: number;
    title: string;
    description: string;
    filterCategory: string;
    subItems?: string[];
  }
@Component({
  selector: 'app-testing-services',
  templateUrl: './testing-services.component.html',
  styleUrls: ['./testing-services.component.css']
})
export class TestingServicesComponent implements OnInit {
    baseUrl = Constants.baseUrl;
    isBrowser:boolean=false;
 

    constructor(
        private titleService: Title,private seoService:SeoService,
        private _renderer2: Renderer2,
        @Inject(DOCUMENT) private _document: Document,
        private metaService: Meta ,   @Inject(PLATFORM_ID) private platformId: any,

      ) {this.isBrowser=isPlatformBrowser(this.platformId);}
      ngOnInit(): void {
        let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
      "@context": "https://schema.org",
      "@type": "Article",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://mitresource.com/testing-services/"
      },
      "headline": "Full Cycle Software Testing Services | Maganti IT",
      "description": "We understand that speed, quality, and productivity are crucial to your success.",
      "image": "https://mitresource.com/assets/images/testingimages/fast-track-img.webp",  
      "author": {
        "@type": "Organization",
        "name": "Maganti IT",
        "url": "https://mitresource.com/"
      },  
      "publisher": {
        "@type": "Organization",
        "name": "Maganti IT",
        "logo": {
          "@type": "ImageObject",
          "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
        }
      },
      "datePublished": "2024-10-28"
    }`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags(); 
    this.seoService.createLinkForCanonicalURL();
         if(this.isBrowser){     
    AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
  }        


      }
ngAfterViewInit(): void {
    if(this.isBrowser){ 
  this.filterdata();
    }
  }
  filterdata(){document.addEventListener('DOMContentLoaded', () => {
    const initialValue = document.querySelector(".filter-button1")?.getAttribute('data-filter');
    document.querySelectorAll(".filter").forEach((element: Element) => {
        if (!element.classList.contains(initialValue!)) {
            (element as HTMLElement).style.display = 'none';
        } else {
            (element as HTMLElement).style.display = 'block';
        }
    });

    const firstFilterButton = document.querySelector(".filter-button1") as HTMLElement;
    firstFilterButton.classList.remove("active");
    firstFilterButton.classList.remove("filter-button-activecolor");
    firstFilterButton.classList.add("active");
    firstFilterButton.classList.add("filter-button-activecolor");

    document.querySelectorAll(".filter-button1").forEach((button: Element) => {
        button.addEventListener('click', function(this: HTMLElement) {
            document.querySelectorAll(".filter-button1").forEach((btn: Element) => {
                btn.classList.remove("active");
                btn.classList.remove("filter-button-activecolor");
            });
            this.classList.add("active");
            this.classList.add("filter-button-activecolor");

            const value = this.getAttribute('data-filter');
            document.querySelectorAll(".filter").forEach((elem: Element) => {
                if (!elem.classList.contains(value!)) {
                    (elem as HTMLElement).style.display = 'none';
                } else {
                    (elem as HTMLElement).style.display = 'block';
                }
            });
        });
    });

    document.querySelectorAll(".filter-button1").forEach((button: Element) => {
        if (button.classList.contains("active")) {
            button.classList.remove("active");
        }
        button.classList.add("active");
    });
})}


private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Full Cycle Software Testing Services');

    this.metaService.addTags([
      { name: 'description', content: 'We understand that speed, quality, and productivity are crucial to your success.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Full Cycle Software Testing Services' },
      { property: 'og:url', content: 'https://mitresource.com/testing-services/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/testingimages/fast-track-img.webp' },
      { property: 'og:description', content: 'We understand that speed, quality, and productivity are crucial to your success.' },
    ])
}
scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  selectedFilter: string = 'aimsFilter';

  cards: Card[] = [
    { id: 1, title: 'GUI Testing', description: 'We specialize in GUI (Graphical User Interface) testing ensuring your software applications offer a seamless and user-friendly experience.   Trust us for precise, detail-oriented testing that enhances the usability and  visual appeal of your software.', filterCategory: 'aimsFilter' },
    { id: 2, title: 'Usability Testing', description: 'Enhance the user-friendliness and overall usability of your software in terms of user interactions, ensuring a seamless experience.', filterCategory: 'aimsFilter' },
    { id: 3, title: 'Functional', description: "Functional testing evaluates your software's functionality and behavior to ensure it aligns with its intended objectives", filterCategory: 'aimsFilter' },
    { 
        id: 4, 
        title: 'Non-functional', 
        description: "Non-functional testing assesses the system's performance, reliability, scalability, and other non-functional attributes.", 
        filterCategory: 'aimsFilter',
        subItems: ['-Performance', '-Compatibility', '-Cross Browser'] // Add subItems array
      },
    { id: 5, title: 'API Testing', description: 'Ensure the reliability and functionality of your application programming interfaces (APIs) for seamless communication between different software components.', filterCategory: 'aimsFilter' },
    { id: 6, title: 'Manual', description: 'We offer meticulous, hands-on approach to ensuring your software performs flawlessly- validating your functionality, usability, and performance.', filterCategory: 'technology' },
    { id: 7, title: 'Automation', description: 'We leverage testing tools and automated scripts are used to perform tests on software applications or system.', filterCategory: 'technology' },
    { id: 8, title: 'Web Applications', description: "Verifying that the web application's core functionalities work as intended. Test cases assess user interactions, form submissions, and data processing to ensure that the application meets its requirements.", filterCategory: 'consulting_staffing' },
    { id: 9, title: 'Mobile Applications', description: 'We evaluate the functionality, performance, usability, security, and compatibility of mobile applications across various devices, operating systems, and network conditions for iOS, Android, cross-platform.', filterCategory: 'consulting_staffing' },
    { id: 10, title: 'Desktop Applications', description: 'Evaluate software applications that are designed to run on desktop or laptop computer- to ensure that these applications work correctly, meet specific functional requirements, provide a positive user experience, and operate securely.', filterCategory: 'consulting_staffing' },
    { id: 11, title: 'Unit', description: 'Unit testing verifies isolated software components (e.g., functions, methods, classes) for correct functionality', filterCategory: 'digital_marketing' },
    { id: 12, title: 'Integration', description: 'Evaluates the interactions and connections between different modules or components of an application to ensure they work together seamlessly as an integrated system.', filterCategory: 'digital_marketing' },
    { id: 13, title: 'System', description: 'Entire integrated system is evaluated to ensure that it functions correctly and meets its intended requirements before it is deployed for actual use', filterCategory: 'digital_marketing' },
    { id: 14, title: 'User Acceptance Testing', description: 'End-users assess and validate the software to ensure it meets their specific requirements and is ready for deployment.', filterCategory: 'digital_marketing' }
  ];

  filterCards(category: string): void {
    this.selectedFilter = category;
  }

  isCardVisible(card: Card): boolean {
    return this.selectedFilter === card.filterCategory;
  }
  brandLogoSlider = {
    slidesToShow: 6,
    slidesToScroll: 1,
    loop: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    breakpoints: {
        1499: {
            slidesPerView: 6
        },

        991: {
            slidesPerView: 4
        },

        767: {
            slidesPerView: 3

        },

        575: {
            slidesPerView: 2
        }
    }
};
  swiperBreakpoints = {
    320: { slidesPerView: 2 },      
    768: { slidesPerView: 4 },      
    1024: { slidesPerView: 6 }      
  };
}
